import { IChartContainer } from "../../models/base/chart-container.interface";
import { IComponent } from "../component.interface";

export class AddComparisonSymbolsButtonComponent implements IComponent {
    public id = '';

    private element: HTMLElement;
    private base: IChartContainer;

    constructor(el: HTMLElement, base: IChartContainer) {
        this.element = el;
        this.base = base;
        this.onClick();
    }

    private onClick() {
        this.element.addEventListener('click', () => {
            this.base.chartService.requestAddComparisonSymbols();
        });
    }
}
